import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import api from '../../api';

const EmployeeLogs = ({ employeeId, showMsg }) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (employeeId) {
      api.get(`/employees/${employeeId}/logs`)
        .then(res => setLogs(res.data))
        .catch(() => showMsg("Failed to load employee logs", "error"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Activity & Audit Logs
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Complete history of profile updates and notifications.
        </Typography>
      </Box>
      <Divider sx={{ mb: 4 }} />

      <Paper elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: 2, overflow: 'hidden' }}>
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Date & Time</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Subject / Action</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Performed By</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                  No activity recorded yet.
                </TableCell>
              </TableRow>
            ) : (
              logs.map(log => {
                // Ensure proper formatting for Indian Standard Time
                const dateObj = new Date(log.timestamp);
                const formattedDate = dateObj.toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata", 
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
                });

                return (
                  <TableRow key={log.id} hover>
                    <TableCell>{formattedDate}</TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>{log.action_subject}</TableCell>
                    <TableCell>{log.performed_by}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default EmployeeLogs;